import { createSlice } from "@reduxjs/toolkit";

export const referralsSlice = createSlice({
  name: "referrals",
  initialState: {
    referralsList: {
      list: [],
      meta: {},
    },
    referralsRewards: {
      list: [],
      meta: {},
    },
  },
  reducers: {
    getReferralsListRequest: () => {},
    getReferralsListResponse: (state, action) => {
      state.referralsList.list = action.payload?.referralsList;
      state.referralsList.meta = action.payload?.meta;
    },
    getReferralsRewardsRequest: () => {},
    getReferralsRewardsResponse: (state, action) => {
      state.referralsRewards.list = action.payload?.referralsRewards;
      state.referralsRewards.meta = action.payload?.meta;
    },
  },
});

export const {
  getReferralsListRequest,
  getReferralsListResponse,
  getReferralsRewardsRequest,
  getReferralsRewardsResponse,
} = referralsSlice.actions;
export default referralsSlice.reducer;
